// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z7w4","largestCol":"styles_largestCol__gMSdB","smallestCol":"styles_smallestCol__2t7GZ"};